<script lang="ts">
    import FeatherIcon from 'svelte-feather-icon';
    import { articalsData } from '../../../Data/FAQ/FAQ';
    import Card from '../../Core/Card.svelte';
</script>
  
{#each articalsData as elem}
  <div class={elem.class}>
    <Card cardProps="bg-primary">
      <div slot="contentbody">
        <div class="media faq-widgets">
          <div class="media-body">
            <h5>{elem.title}</h5>
            <p>{elem.para}</p>
          </div>
          <FeatherIcon icon={elem.icon} />
        </div>
      </div>
    </Card>
  </div>
{/each}
  